module.exports = __webpack_public_path__ + "static/img/icon_input.2fdf03c7.svg";